module.exports = {
	"config": {
		"siteTitle": "defcon402",
		"siteDescr": "Security in the midwest.",
		"siteAuthor": "Adam Schaal",
		"siteTwitterUrl": "https://twitter.com/defcon402",
		"siteGithubUrl": "https://github.com/DEFCON402/DEFCON402.github.io",
		"sitelinkedInUrl": "https://www.linkedin.com/groups/13554437",
		"siteEmailUrl": "mailto:info@dc402.org",
		"siteFacebookUrl": "https://www.facebook.com/DC402/",
		"siteYouTubeUrl": "#",
		"googleAnalyticsId": "UA-109234778-1",
		"linkPrefix": "/"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html",
				"layout": "page"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "faire2018.md",
				"ext": "md",
				"name": "faire2018",
				"extname": ".md",
				"basename": "faire2018.md",
				"dirname": "",
				"stem": "faire2018",
				"path": "faire2018.md"
			},
			"requirePath": "faire2018.md",
			"path": "/faire2018/",
			"data": {
				"title": "Omaha Mini Maker Faire 2018",
				"layout": "page",
				"path": "/faire2018/",
				"priority": 0,
				"boldText": "Omaha Mini Maker Faire 2018.",
				"highlightTitle": "Join us Saturday Apr 14 at Omaha doSpace from 9 AM until 4 PM."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx"
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "primary-nav-pages/about",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "primary-nav-pages/about",
				"stem": "index",
				"path": "primary-nav-pages/about/index.md"
			},
			"requirePath": "primary-nav-pages/about/index.md",
			"path": "/about/",
			"data": {
				"title": "About Us",
				"layout": "page",
				"path": "/about/",
				"iconType": "ABOUTUS",
				"priority": 0,
				"className": "about-viewport"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "primary-nav-pages/code-of-conduct",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "primary-nav-pages/code-of-conduct",
				"stem": "index",
				"path": "primary-nav-pages/code-of-conduct/index.md"
			},
			"requirePath": "primary-nav-pages/code-of-conduct/index.md",
			"path": "/code-of-conduct/",
			"data": {
				"title": "Code of Conduct",
				"layout": "page",
				"path": "/code-of-conduct/",
				"priority": 1,
				"hide": true
			}
		},
		{
			"file": {
				"root": "",
				"dir": "primary-nav-pages/contact-us",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "primary-nav-pages/contact-us",
				"stem": "index",
				"path": "primary-nav-pages/contact-us/index.md"
			},
			"requirePath": "primary-nav-pages/contact-us/index.md",
			"path": "/contact/",
			"data": {
				"title": "Contact Us",
				"layout": "page",
				"path": "/contact/",
				"iconType": "CONTACTUS",
				"priority": 1,
				"hide": true
			}
		},
		{
			"file": {
				"root": "",
				"dir": "primary-nav-pages/faq",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "primary-nav-pages/faq",
				"stem": "index",
				"path": "primary-nav-pages/faq/index.md"
			},
			"requirePath": "primary-nav-pages/faq/index.md",
			"path": "/faq/",
			"data": {
				"navTitle": "FAQ",
				"title": "Frequently Asked Questions",
				"layout": "page",
				"path": "/faq/",
				"iconType": "FAQ",
				"priority": 2,
				"className": "faq-viewport"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "primary-nav-pages/source",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "primary-nav-pages/source",
				"stem": "index",
				"path": "primary-nav-pages/source/index.md"
			},
			"requirePath": "primary-nav-pages/source/index.md",
			"path": "/primary-nav-pages/source/",
			"data": {
				"title": "Source",
				"layout": "page",
				"href": "https://github.com/DEFCON402/DEFCON402.github.io",
				"iconType": "SOURCE",
				"priority": 4
			}
		},
		{
			"file": {
				"root": "",
				"dir": "primary-nav-pages/speak",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "primary-nav-pages/speak",
				"stem": "index",
				"path": "primary-nav-pages/speak/index.md"
			},
			"requirePath": "primary-nav-pages/speak/index.md",
			"path": "/primary-nav-pages/speak/",
			"data": {
				"title": "Speak",
				"layout": "page",
				"href": "https://goo.gl/forms/CX0CMBDszowuQaak2",
				"iconType": "SPEAK",
				"priority": 3
			}
		},
		{
			"file": {
				"root": "",
				"dir": "primary-nav-pages/sponsor",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "primary-nav-pages/sponsor",
				"stem": "index",
				"path": "primary-nav-pages/sponsor/index.md"
			},
			"requirePath": "primary-nav-pages/sponsor/index.md",
			"path": "/sponsor/",
			"data": {
				"navTitle": "Sponsor",
				"title": "Sponsor Information",
				"layout": "page",
				"path": "/sponsor/",
				"iconType": "SLIDES",
				"priority": 2
			}
		},
		{
			"file": {
				"root": "",
				"dir": "r/1",
				"base": "index.html",
				"ext": "html",
				"name": "index",
				"extname": ".html",
				"basename": "index.html",
				"dirname": "r/1",
				"stem": "index",
				"path": "r/1/index.html"
			},
			"requirePath": "r/1/index.html",
			"path": "/r/1/",
			"data": {
				"body": "<!DOCTYPE HTML>\n<html lang=\"en-US\">\n    <head>\n        <meta charset=\"UTF-8\">\n        <meta http-equiv=\"refresh\" content=\"1;url=http://dc402.org/files/omahaminimakerfaire2018/\">\n        <script type=\"text/javascript\">\n            window.location.href = \"http://dc402.org/files/omahaminimakerfaire2018/\"\n        </script>\n        <title>Crappy Github pages poor-man's URL shortener</title>\n    </head>\n    <body>\n        If you are not redirected automatically, follow the <a href='http://dc402.org/files/omahaminimakerfaire2018/'>link</a>.\n    </body>\n</html>\n"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "secondary-nav-pages/connect",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "secondary-nav-pages/connect",
				"stem": "index",
				"path": "secondary-nav-pages/connect/index.md"
			},
			"requirePath": "secondary-nav-pages/connect/index.md",
			"path": "/connect/",
			"data": {
				"title": "Connect",
				"layout": "page",
				"path": "/connect/",
				"priority": 0,
				"boldText": "Reach out.",
				"highlightTitle": "Join and support your local groups.",
				"bigIcons": true
			}
		},
		{
			"file": {
				"root": "",
				"dir": "secondary-nav-pages/schedule",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "secondary-nav-pages/schedule",
				"stem": "index",
				"path": "secondary-nav-pages/schedule/index.md"
			},
			"requirePath": "secondary-nav-pages/schedule/index.md",
			"path": "/schedule/",
			"data": {
				"title": "Schedule",
				"layout": "page",
				"path": "/schedule/",
				"priority": 0,
				"boldText": "Meet up.",
				"highlightTitle": "Find others who share your passion."
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 394
// module chunks = 0